import axios from 'axios';
import moment from 'moment';

/* eslint-disable camelcase */
type RevenueCatResponse = {
  request_date: string;
  request_date_ms: number;
  subscriber: {
    entitlements: {
      pro_cat: {
        expires_date: Date;
        product_identifier: string;
        purchase_date: string;
      };
    };
    first_seen: string;
    non_subscriptions: {
      onetime: [
        {
          id: string;
          is_sandbox: true;
          purchase_date: string;
          store: string;
        },
      ];
    };
    original_app_user_id: string;
    original_application_version: string;
    other_purchases: {
      onetime: {
        purchase_date: string;
      };
    };
    subscriptions: {
      annual: {
        billing_issues_detected_at: string;
        expires_date: string;
        is_sandbox: boolean;
        original_purchase_date: string;
        period_type: 'normal' | 'trial';
        purchase_date: string;
        store: string;
        unsubscribe_detected_at: string;
      };
      onemonth: {
        billing_issues_detected_at: string;
        expires_date: string;
        is_sandbox: boolean;
        original_purchase_date: string;
        period_type: 'normal' | 'trial';
        purchase_date: string;
        store: string;
        unsubscribe_detected_at: string;
      };
      rc_promo_pro_cat_monthly: {
        billing_issues_detected_at: string;
        expires_date: string;
        is_sandbox: boolean;
        original_purchase_date: string;
        period_type: 'normal' | 'trial';
        purchase_date: string;
        store: string;
        unsubscribe_detected_at: string;
      };
    };
  };
};

export async function getSubscriptionStatus(userId: string): Promise<boolean> {
  try {
    const response = await axios.request<boolean>({
      method: 'GET',
      url: `https://api.revenuecat.com/v1/subscribers/${userId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_REVENUE_CAT_PUBLIC_KEY}`,
      },
      transformResponse: [
        (data) => {
          const dataTransformedToJson: RevenueCatResponse = JSON.parse(data);
          return hasActiveEntitlement(dataTransformedToJson.subscriber);
        },
      ],
    });

    return response.data;
  } catch (error: any) {
    if (error.response !== undefined) {
      throw new Error(`Something went wrong with response: ${error.response}`);
    } else if (error.request !== undefined) {
      throw new Error(`Something went wrong with no response. Request: ${error.request}`);
    } else {
      throw new Error(`Something went wrong when setting up the request: ${error.message}`);
    }
  }
}

function hasActiveEntitlement(customer: RevenueCatResponse['subscriber']) {
  return Object.values(customer.entitlements).some((entitlement) =>
    entitlementIsActive(entitlement)
  );
}

function entitlementIsActive(entitlement) {
  const currentDate = moment.utc();
  return entitlement.expires_date === null || currentDate.isBefore(entitlement.expires_date);
}
